import React from 'react';
import './Regulation.css';

const Regulation = () => {
  // Ви можете зробити ці дані динамічними, якщо потрібно
  const lastUpdated = "25 листопада 2025 р";
  const companyName = "ФОП Кілочик Олексій Олександрович.";

  return (
    <div className="agreement-wrapper">
      <div className="agreement-container">
        <header className="agreement-header">
          <h1>ПРАВИЛА, УМОВИ ТА ОТРИМУВАЧ КОШТІВ</h1>
          <p>
            Останнє оновлення: {lastUpdated}.
          </p>
        </header>

        <section className="agreement-content">
          <div className="policy-section">
            <h2>Pryvitai.com</h2>
            <p>1. Оплата замовлення здійснюється через надійного платіжного провайдера Wayforpay, який відповідає міжнародним стандартам безпеки платежів PCI DSS та має відповідну ліцензію. Отримувач коштів — ФОП Кілочик Олексій Олександрович. ЄДРПОУ 3483004095. Адреса: с. Солониця, вул. Злуки 27, Полтавської обл. Лубенського р-н., тел.: 0662428092, email: a.kilochyk@gmail.com.
Ви надаєте інформацію для формування платіжної інструкції та згоду на виконання платіжної операції, а також акцептуєте:
</p>
        <p>Умови публічної оферти Wayforpay <a href="https://wayforpay.com/wfp/files/oferta.pdf">(детальніше)</a></p>
        <p>Можлива комісія банку:</p>
            <ul>
              <li>0,5 – 1,5% + 5 ₴ за тарифами переказів з картки на картку;</li>
              <li>4% у разі використання кредитних коштів;</li>
            </ul>
        <p>Комісія не зменшує суму замовлення і сплачується додатково.</p>
        <p>2. Погоджуюся із Політикою конфіденційності сайту <a href="https://pryvitai.com">pryvitai.com</a></p>
        <p>3. Порядок та терміни надання товару:</p>
            <ul>
              <li>Беремо зобов`язання активувати послугу генерації зображень до привітань та листівок протягом дня (здебільшого декілька хвилин). Послуга буде активна відповідно до обраного <a href="https://pryvitai.com/tariffs">тарифного плану</a>.</li>
            </ul>
        <p>4. Правила повернення грошових коштів:</p>
            <ul>
              <li>Кошти можна повернути в повному обсязі за умови якщо послуги за тарифом ще не було використано. Якщо користувач почав використовувати можливості тарифу враховуючи при цьому рекомендації та <a href="https://pryvitai.com/userTips">поради</a> але отримав більш ніж 40% незадовільних результатів можна звернутися для індивідуального вирішення за контактами, ми завжди відкриті до зворотного зв’язку і готові шукати компромісні рішення, щоб зробити сервіс кращим, результати точнішими клієнтів задоволенішими.</li>
            </ul>
          </div>



        </section>
      </div>
    </div>
  );
};

export default Regulation;